import * as Sentry from "@sentry/browser";
import configureStore from "core-integration/src/configureStore";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router";
import { initializeGtm } from "shared-utils/src/gtm";
import App from "./components/App";
import "./i18n";
import * as serviceWorker from "./serviceWorker";

if (import.meta.env.VITE_SENTRY_ENVIRONMENT) {
  Sentry.init({
    dsn: "https://f138bb7f42474ff7a5032f7d338b4135@sentry.io/2243032",
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    allowUrls: [/eliteserien\.no/, /ismgames\.com/],
    ignoreErrors: [],
  });
}

initializeGtm(import.meta.env.VITE_GTM_ID);

const container = document.getElementById("root")!;
const root = createRoot(container);

// Create a data router to support useBlocker hook
const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <Provider store={configureStore()}>
        <App />
      </Provider>
    ),
  },
]);

root.render(<RouterProvider router={router} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
